import en from './en.json';
import th from './th.json';
import cn from './cn.json';

export default {
  en,
  th,
  cn,
};
